import { AxiosResponse } from 'axios';
import { Template, TemplateType } from 'src/types/templates';
import { TemplateService } from './templateService';

export interface ApiTemplates {
    create(template: Template): Promise<AxiosResponse>;
    getById(templateId: string): Promise<AxiosResponse>;
    update(template: Template): Promise<AxiosResponse>;
    getMessagingTemplates(): Promise<AxiosResponse>;
    getVoiceTemplates(): Promise<AxiosResponse>;
    getAiSummaryTemplates(): Promise<AxiosResponse>;
    getTemplatesByQueueId(queueId: string): Promise<AxiosResponse>;
    getVariables(templateType: TemplateType): Promise<AxiosResponse>;
    testPrompt(prompt: string, templateType: TemplateType): Promise<AxiosResponse>;
}

export const templateService = new TemplateService();